import React from 'react';
import styles from './List.module.scss';
export const List = ({ items, variant = 'bullet' }) => {
    return (<ul className={styles[variant]}>
      {items.map((item) => (<li className={styles.listItem} key={typeof item === 'string' ? item : `${item.text}-${item === null || item === void 0 ? void 0 : item.span}`}>
          {typeof item === 'string' ? item : item.text}
          {typeof item === 'string' ? '' : <span>{item === null || item === void 0 ? void 0 : item.span}</span>}
        </li>))}
    </ul>);
};
